import React from 'react'

import DropdownIncremental from '../answers/DropdownIncremental'
import Input from '../answers/updated/Input'
import Toggle from '../answers/updated/Toggle'
import Height from '../answers/updated/Height'
import DateOfBirth from '../answers/updated/DateOfBirth'
import TableSlider from '../answers/updated/TableSlider'
import CheckboxYesNo from '../answers/updated/CheckboxYesNo'
import InputText from '../answers/updated/InputText'

const AnswerComponentTranslation = {
    "TOGGLE": Toggle,
    "DECIMAL INPUT": Input,
    "INTEGER INPUT": Input,
    "TEXT INPUT": InputText,
    "DATE INPUT": DateOfBirth,
    "SLIDER": TableSlider,
    "HEIGHT": Height,
    "CHECKBOX": CheckboxYesNo
}

/**
 * "SLIDER": TableSlider,
    "DECIMAL INPUT": Input,
    "INTEGER INPUT": Input,
    "HEIGHT": Height,
    "DROPDOWN INCREMENTAL": DropdownIncremental,
    "DROPDOWN": Dropdown
 * 
 */

const AnswerContainer = (props) => {
    if (typeof AnswerComponentTranslation[props.QuestionTypeKeyName] !== "undefined") {
        return React.createElement(AnswerComponentTranslation[props.QuestionTypeKeyName]
            , {
                key: "ANS_" + props.QuestionId,
                question: props,
                saveAnswer: props.saveAnswer,
                QuestionStandardContent: props.QuestionStandardContent
            }
        )
    }

    return React.createElement(
        () => <div></div>
    )
}

export default AnswerContainer